import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
  FormHelperText,
  FormHelperTextProps,
} from "@mui/material";
import { ReactElement } from "react";
import {
  FieldValues,
  useController,
  UseControllerProps,
} from "react-hook-form";

import { palette } from "~frontend/theme";

export function RhfSwitchField<T extends FieldValues>(
  props: SwitchProps &
    UseControllerProps<T> & {
      label?: string;
      labelProps?: FormControlLabelProps;
      helperText?: string;
      helperTextProps?: FormHelperTextProps;
      bottomLabel?: string;
      color?:
        | "primary"
        | "secondary"
        | "default"
        | "error"
        | "info"
        | "success"
        | "warning";
    }
): ReactElement {
  const {
    control: _control,
    helperText,
    helperTextProps,
    labelProps,
    ...switchProps
  } = props;

  const { field, fieldState } = useController(props);

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            sx={{
              "+ .MuiTypography-root": {
                color: field.value ? palette.navy : palette.darkGray,
              },
            }}
            color={fieldState.error ? "secondary" : (props.color ?? "primary")}
            checked={!!field.value}
            {...switchProps}
            onChange={(evt: React.ChangeEvent<HTMLInputElement>, checked) => {
              if (switchProps?.onChange) {
                switchProps.onChange(evt, checked);
                if (evt.isDefaultPrevented()) {
                  return;
                }
              }

              return field.onChange(evt);
            }}
            onBlur={field.onBlur}
          />
        }
        label={switchProps.label}
        {...labelProps}
      />
      {helperText ? (
        <FormHelperText {...helperTextProps}>{helperText}</FormHelperText>
      ) : null}
    </>
  );
}
